export const QueryKeys = {
  permissions: (accessToken: string) => ['permissions', accessToken]
}
